import { NodeCategoryModel } from 'src/modules/network-configuration/models/node-data';
import {
  IConfigurationDhcpclient,
  IConfigurationDhcpInterface,
} from 'src/types/configuration';

export const configurationDhcpClient = ({
  nodeCategory,
  isAutoDeploy,
}: {
  nodeCategory: NodeCategoryModel;
  isAutoDeploy: boolean;
}): IConfigurationDhcpclient => {
  const defaultDhcpClient: IConfigurationDhcpclient = {
    interfaces: [],
    version: 1,
  };

  const defaultInterfaceItem: IConfigurationDhcpInterface = {
    filter: false,
    id: 0,
    operation: false,
    provision: false,
  };

  const interfaceItem: IConfigurationDhcpInterface[] = [];
  interfaceItem.push(defaultInterfaceItem);
  if (!nodeCategory.ipInterfaces || nodeCategory.ipInterfaces.length === 0) {
    defaultDhcpClient.interfaces = interfaceItem.sort((a, b) => a.id - b.id);
    return defaultDhcpClient;
  }

  nodeCategory.ipInterfaces.forEach((ipInterface) => {
    interfaceItem.push({
      ...defaultInterfaceItem,
      id: parseInt(ipInterface.vlanId.toString(), 10),
    });
  });

  defaultDhcpClient.interfaces = interfaceItem.sort((a, b) => a.id - b.id);

  if (isAutoDeploy) {
    defaultDhcpClient.interfaces.push({
      filter: false,
      id: 3579,
      operation: false,
      provision: false,
    });
  }

  return defaultDhcpClient;
};
